<template>
  <div class="roles-main">
    <el-card class="box-card" shadow="never">
      <template #header>
        <div class="clearfix">
          <span class="role-span">{{ $t('fields.creditFlow') }}</span>
        </div>
      </template>
      <el-tabs v-model="activeName">
        <el-tab-pane
          :label="t('fields.creditFlow')"
          name="money-change-record"
          v-if="parseInt(store.state.user.siteId) === 37"
        >
          <moneyChangeTab />
        </el-tab-pane>
        <el-tab-pane
          :label="t('fields.commissionWallet')"
          name="commission-wallet"
          v-if="parseInt(store.state.user.siteId) !== 37"
        >
          <commissionWalletTab />
        </el-tab-pane>
        <el-tab-pane
          :label="t('fields.depositWallet')"
          name="deposit-wallet"
          v-if="parseInt(store.state.user.siteId) !== 37"
        >
          <depositWalletTab />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import commissionWalletTab from './tab/commission-wallet.vue'
import moneyChangeTab from './tab/money-change-record.vue'
import depositWalletTab from './tab/deposit-wallet.vue'
import { useStore } from '@/store'
console.log('')
const { t } = useI18n()
const store = useStore()
const activeName = ref('commission-wallet')

onMounted(() => {
  if (parseInt(store.state.user.siteId) === 37) {
    activeName.value = 'money-change-record'
  }
})
</script>
